/**
 * @file Created on Wed Aug 22 2018
 * @author BPo
 */
import { RenderPropsProvider } from './RenderPropsProvider';
export default RenderPropsProvider;